package one.healthium.insights.domain.content

import kotlinx.serialization.Serializable

@Serializable
sealed class ContentOptions {
    abstract val id: String

    @Serializable
    data class Category(override val id: String) : ContentOptions()

    @Serializable
    data class Insight(override val id: String) : ContentOptions()

    @Serializable
    data class Recipe(override val id: String) : ContentOptions()

    @Serializable
    data class MealPlan(override val id: String) : ContentOptions()

    @Serializable
    data class Workout(override val id: String) : ContentOptions()
}
